import Script from 'next/script'

/*
 * DO NOT CHANGE THIS CODE WITHOUT GOOD REASON!
 *
 * Renders the Zendesk Web Widget script for the active site.
 * Provided keys (per user spec):
 *  UK -> 115712f7-72a0-48c5-9377-09037fe5f404
 *  IE -> 4314daa6-3e52-4a4f-8e25-6cbd790c99e5
 *  FF -> 4b87e66b-db10-4f78-bb4c-046b606ea810
 *
 * Usage: renderZendeskScript(siteShorthand) where siteShorthand is one of: 'uk' | 'ie' | 'ff'
 * Default falls back to UK if an unknown/undefined shorthand is supplied (mirrors iAdvize pattern simplicity).
 */

export function renderZenDeskScript(siteShorthand?: string) {
  const zenDeskId = getZenDeskId(siteShorthand?.toLowerCase())

  return zenDeskId ? (
    <Script
      id="ze-snippet"
      src={`https://static.zdassets.com/ekr/snippet.js?key=${zenDeskId}`}
      strategy="afterInteractive"
    />
  ) : (
    ''
  )
}
/**
 * Get the ZenDesk ID. This should always be available in the
 * sever-side code as `process.env.ZEN_DESK_ID`, but may also be required when
 * events are fired from the client-side code, where it can be found in
 * `process.env.NEXT_PUBLIC_ZEN_DESK_ID`
 */
function getZenDeskId(siteShorthand?: string) {
  switch (siteShorthand) {
    case 'uk':
      return process.env.NEXT_PUBLIC_ZEN_DESK_ID_UK || process.env.ZEN_DESK_ID_UK
    case 'ie':
      return process.env.NEXT_PUBLIC_ZEN_DESK_ID_IE || process.env.ZEN_DESK_ID_IE
    case 'ff':
      return process.env.NEXT_PUBLIC_ZEN_DESK_ID_FF || process.env.ZEN_DESK_ID_FF
    default:
      break
  }
}
